import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function SuperChickenRushPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    const { showOnlyOnFomo } = theme.config;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7": 'IW247';

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    {
                        (brandId == 31 || brandId == 32) ? <p>Win up to <span className='brandColor'>₹90,000 Cash</span> this September on Evoplay</p> :
                            (brandId == 33 || brandId == 34) ? <p>Enjoy <span className='brandColor'>₹3000 daily</span> rewards on Uncrossable Rush - <span className='brandColor'>the more you spin, the more you win!</span></p> :
                                (brandId == 61) ? <p>🎁 Win up to <span className='brandColor'>$900 Cash</span> this September on Evoplay</p> :
                                <p>Get <span className='brandColor'>₹3,000 daily</span> on Uncrossable Rush - just keep spinning!</p>
                    }
                </TitleText>
                <ImageWrapper>
                    <Container>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                           <Link to='/slots/evoplay/uncrossable-rush' className='playNowBtn'><span>Play Now</span></Link>
                    </Container>
                </ImageWrapper> 

                {(brandId == 39 || brandId == 40) && <BorderLine></BorderLine>}

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon1}`}/>
                            <p>Play Uncrossable Rush daily on {domain}.</p>
                        </KeyDetailsSecBox>
                             
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon2}`}/>
                            <p>Spin the required number of rounds to unlock Free Cash.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon3}`}/>
                            {(brandId == 61) ? <p>Claim up to $30 Free cash every day.</p> : <p>Claim up to ₹3,000 Free cash every day.</p>}
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <PriceBreakDown className={(brandId == 39 || brandId == 40) ? 'bgRadial' : ''}>
                    {(brandId == 31 || brandId == 32) ? <MainTitle>How Free Rounds Unlocks?</MainTitle> : <MainTitle>How Free Cash Unlocks?</MainTitle>}
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}
                    <SliderWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushFreeRoundPrice}`}
                            alt="How Free Rounds Unlocks"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </SliderWrapper>
                </PriceBreakDown>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}

                    {(brandId == 61) ? 
                        <ul>
                            <li>✪ only bets of $1 or more per spin qualify.</li>
                            <li>✪ Winnings from Free Cash capped at 1x per day.</li>
                            <li>✪ Maximum of $30 per day per player.</li>
                            <li>✪ Standard brand T&Cs apply</li>
                        </ul> 
                        : 
                        <ul>
                            <li>✪ Only bets of ₹75 or more per spin qualify.</li>
                            <li>✪ Winnings from Free Cash capped at 1x per day.</li>
                            <li>✪ Maximum of ₹3,000 per day per player.</li>
                            <li>✪ Standard brand T&Cs apply.</li>
                        </ul>
                    }
                </TermsAndCondition>
                
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(SuperChickenRushPromo));

const BorderLine = styled.div`
    width: 100%;
    background: ${theme('palette.jiliPlaySpinBorderLineBg')};
    height: 1px;
    align-self: center;
`;

const UnderLine = styled.div`
    height: 1px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);

    &.paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    &.marginTop {
        margin: 0 auto;
        margin-top: 1rem;
    }
`;

const SliderWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 738px;
        max-width: 100%;
    }
`;

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.suprChknRushMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .boldText {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .brandColor {
        color: ${theme('palette.suprChknRushBrandTextColor')};
        font-weight: 700;
    }

    .bgRadial {
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }
`;

const PriceBreakDown = styled.div`
    width: 80%;
    padding: 2rem 0;
    position: relative;
    margin: auto;
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 15px;

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
    }

    .mt-10 {
        margin-top: 15px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    padding-top: ${theme('palette.suprChknRushImageWraprPaddngTop')};

    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;

const Container = styled.div`
    width: 275px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

    .playNowBtn {
        width: 220px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 1.5rem;
        border-radius: 60px;
        border: ${theme('palette.suprChknRushPlayNowBtnBorder')};
        background: ${theme('palette.suprChknRushPlayNowBtnBgColor')};

        :hover {
            background: #fff;
            border: 3px solid #bebebe;
        }
    }

`;

const MainTitle = styled.h4`
    color: ${theme('palette.weeklySepLeaderboardText')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`;

const KeyDetailsSecBox = styled.div`
    width: 27%;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: ${theme('palette.weeklySepLeaderBoardPartBoxBodrRadus')};
    border: 0.5px solid ${theme('palette.weeklySepLeaderBoardPartBoxBorder')};
    background: ${theme('palette.weeklySepLeaderBoardPartBoxBg')};

    img {
        width: 61px;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 14px;
    border: ${theme('palette.suprChknRushTCBorder')};
    background: ${theme('palette.suprChknRushTCBg')};
    padding: 1rem;
    backdrop-filter: ${theme('palette.suprChknRushTCBGFilter')};
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #fff;
            font-size: 16px;
            text-transform: capitalize;
        }
    }
`;